/**
 * Known IMAP/SMTP hosts for custom domains whose mail is hosted elsewhere
 * (e.g. IONOS) and whose own imap./mail. DNS records do not exist.
 * Used to prefill reconnect and to send a working host when the backend
 * has not yet returned stored server settings.
 */
export const IMAP_DOMAIN_HINTS = {
  "projektsteuerung.pro": {
    host: "imap.ionos.de",
    port: 993,
    tls: true,
    smtpHost: "smtp.ionos.de",
    smtpPort: 587,
    smtpSecure: false,
  },
  "bl2020.com": {
    host: "mail.digishop.de",
    port: 993,
    tls: true,
    smtpHost: "mail.digishop.de",
    smtpPort: 465,
    smtpSecure: true,
  },
};

export function imapHintForEmail(email) {
  const domain = String(email || "")
    .split("@")[1]
    ?.toLowerCase()
    .trim();
  if (!domain) return null;
  return IMAP_DOMAIN_HINTS[domain] || null;
}

export function imapFormFromAccount(account = {}) {
  const hint = imapHintForEmail(account.email);
  const host = account.imapHost || hint?.host || "";
  const smtpHost = account.smtpHost || hint?.smtpHost || "";
  const hasStoredSmtp = account.smtpHost || account.smtpPort !== undefined;
  return {
    user: account.email || "",
    password: "",
    host,
    port: String(account.imapPort || hint?.port || 993),
    tls: account.imapTls !== undefined ? account.imapTls !== false : hint?.tls !== false,
    smtpHost,
    smtpPort: String(
      hasStoredSmtp ? (account.smtpPort || hint?.smtpPort || 587) : (hint?.smtpPort || 587)
    ),
    smtpSecure: hasStoredSmtp
      ? !!account.smtpSecure
      : !!(hint?.smtpSecure),
  };
}

export function applyImapHostHint(payload = {}) {
  const hint = imapHintForEmail(payload.user);
  if (!hint) return payload;
  return {
    ...payload,
    host: payload.host || hint.host,
    port: payload.port || hint.port,
    tls: payload.tls !== undefined ? payload.tls : hint.tls,
    smtpHost: payload.smtpHost || hint.smtpHost,
    smtpPort: payload.smtpPort || hint.smtpPort,
    smtpSecure: payload.smtpSecure !== undefined ? payload.smtpSecure : hint.smtpSecure,
  };
}
